import { render, staticRenderFns } from "./PreIngressRegions.vue?vue&type=template&id=2b8c7980"
import script from "./PreIngressRegions.vue?vue&type=script&lang=js"
export * from "./PreIngressRegions.vue?vue&type=script&lang=js"
import style0 from "./PreIngressRegions.vue?vue&type=style&index=0&id=2b8c7980&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports